import { Component, Input } from '@angular/core';
import { eGENA_Checkliste } from '../../../visionet/Checkliste';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';


@Component({
	selector: 'Textsuche',
	templateUrl: 'Textsuche.html'
})

export class TextsucheComponent {

	@Input()
	curSearchResultChecklists: eGENA_Checkliste[]
	@Input()
	ausgewaehlterPatiententyp: string;
	@Input()
	activeSearch: string = ''


	constructor(public globals: GlobalsSingleton) {
	}


	azButtons: string[] = []

	isTablettOrPc() : boolean {
		return !this.globals.isPhone();
	}

}



// WEBPACK FOOTER //
// ./src/components/Suche/Textsuche/Textsuche.ts